import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

// The single show/hide password input used EVERYWHERE a password is typed
// (login, register, reset, change). Defaults to hidden and resets to hidden on
// every mount — "shown" never persists across pages/sessions. The toggle is a
// real <button type="button"> so it's keyboard-reachable (space/enter) and never
// submits the form.
export function PasswordInput({
  id,
  value,
  onChange,
  testId = "password",
  inputTestId,
  toggleTestId,
  autoComplete = "current-password",
  required = false,
  placeholder,
  className = "",
}) {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <input
        id={id}
        data-testid={inputTestId || `${testId}-input`}
        type={show ? "text" : "password"}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        autoComplete={autoComplete}
        required={required}
        placeholder={placeholder}
        className={`w-full bg-input border border-sniper focus:border-olive outline-none px-3 py-2.5 pr-11 text-foreground font-body transition-colors ${className}`}
      />
      <button
        type="button"
        data-testid={toggleTestId || `${testId}-toggle`}
        onClick={() => setShow((s) => !s)}
        aria-label={show ? "Hide password" : "Show password"}
        aria-pressed={show}
        title={show ? "Hide password" : "Show password"}
        className="absolute right-2 top-1/2 -translate-y-1/2 p-1 text-muted-foreground hover:text-foreground transition-colors"
      >
        {show ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
      </button>
    </div>
  );
}
